import axios from 'axios';
import Api from '../api/ApiUrl';
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
export const sendGlobalNotification = async (data) => {
  const response = await axios.post(`${Api}/api/v1/notificationsadmin/send-global-notification`, data,config);
  return response.data;
};

export const scheduleNotification = async (data) => {
  const response = await axios.post(`${Api}/api/v1/notificationsadmin/schedule-notification`, data,config);
  return response.data;
};

export const getAllNotifications = async () => {
  const response = await axios.get(`${Api}/api/v1/notificationsadmin/get-all-notifications`,config);
  return response.data;
};

export const deleteNotification = async (id) => {
  const response = await axios.delete(`${Api}/api/v1/notificationsadmin/${id}`,config);
  return response.data;
};
